var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-loading",attrs:{"id":"app-loading"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"warning"}}),_vm._v(" "),_c('span',{staticClass:"app-loading-message"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f5c5d37","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/plugins/loading/AppLoading.vue
// module id = null
// module chunks = 